import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalType: null,
  message: null,
};

const slice = createSlice({
  name: 'modalStripReducer',
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      state.modalType = action.payload.modalType;
      state.message = action.payload.message;
    },
    closeModal: (state) => {
      state.modalType = null;
      state.message = null;
    },
  },
});

export const { openModal, closeModal } = slice.actions;

export default slice.reducer;
